import { render, staticRenderFns } from "./SingleWallet.vue?vue&type=template&id=7de57c28&scoped=true&"
import script from "./SingleWallet.vue?vue&type=script&lang=js&"
export * from "./SingleWallet.vue?vue&type=script&lang=js&"
import style0 from "./SingleWallet.vue?vue&type=style&index=0&id=7de57c28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de57c28",
  null
  
)

export default component.exports